import { partnerService, Partner } from "./partnerService";

interface Agewell extends Partner {
  // Add any additional properties specific to Agewell here
}

// Agewell service.
// This service is used to store and retrieve the Agewell object.
//
const partnerAgewellService = {
  isActive: () => {
    return !!getPartnerObject();
  },

  onIndexMounted: (location: Location) => {
    const partner = getPartnerObject();
    if (!partner) return;

    // Add any Agewell-specific initialization logic here
    // For example, handling specific query parameters

    setPartnerObject(partner);
  },

  // Add any additional methods specific to Agewell here
};

const getPartnerObject = () => {
  const partner = partnerService.getPartner();
  if (partner && partner.name.toLowerCase().trim() === "agewell") {
    return partner as Agewell;
  }
  return undefined;
};

const setPartnerObject = (partner: Agewell) => {
  partnerService.setPartner(partner);
};

export { partnerAgewellService, Agewell };
